<template>
    <integration-layout>
        <integration-jira
            :base_url="base_url"
            :location="location"
            :recsec="recorder_secret"
            :project_key="project_key"
            :project_id="project_id"></integration-jira>

    </integration-layout>
</template>

<script>

    import IntegrationLayout from "@/Layouts/IntegrationLayout"
    import IntegrationJira from '@/Components/Integrations/Jira/IntegrationJira'

    export default {
        name: "JiraApp",

        props: [
            'location',
            'recorder_secret',
            'base_url',
            'project_key','project_id'
        ],


        components: {
            IntegrationLayout, IntegrationJira,

        },
        data() {
            return {

            }
        },
        created() {



        },
        beforeUnmount() {

        },
        mounted() {

        },
        computed: {

        },
        methods: {

        }
    }
</script>

<style scoped>


.fade-enter-active, .fade-leave-active {
    transition: opacity .5s ease;
}
.fade-enter-from, .fade-leave-to {
    opacity: 0;
}


.slide-fade-enter-active {
    transition: all .3s ease-out;
}
.slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateY(20px);
    opacity: 0;
}


</style>
